import { Chip } from '@mui/material';

const ComingSoonBadge: React.FC = () => (
  <Chip className="f10" color="primary" size="small" label="Coming Soon" />
);

export default ComingSoonBadge;
